import { CancelToken } from "axios";
import api from "./api";
import { PriceListAndSettingRes } from "interfaces/response";
import { PriceListAndSettingReq } from "interfaces/request";
import { GET_INIT_PRICE_AND_SETTING } from "constants/api";

export const getInitPriceListAndSettings = (payload: PriceListAndSettingReq, cancelToken: CancelToken) => {
    return api.post<PriceListAndSettingRes>(GET_INIT_PRICE_AND_SETTING, payload, { cancelToken });
};
